import { Button, IconButton, Modal, TextField } from '@mui/material';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { ClearIcon } from 'components/icons';
import { useNotificationProvider } from 'hooks';
import React, { useState } from 'react';

interface CheckpointCommentResponseProps {
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	error: boolean;
	helperText: string;
	label: string;
	autoFillDropdownItems?: string[];
}

const style = {
	position: 'absolute' as 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '90%',
	maxHeight: '90%',
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 2,
	display: 'flex',
	flexDirection: 'column',
	gap: '1rem',
	overflowY: 'auto',
};

const CheckpointCommentResponse: React.FC<CheckpointCommentResponseProps> = (
	props,
) => {
	const { label, value, onChange, error, helperText, autoFillDropdownItems } =
		props;
	const { notifySuccess } = useNotificationProvider();
	const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

	const onAutoFillDropdownItemClick = (item: string) => {
		onChange({
			target: {
				value: value + item,
			},
		} as React.ChangeEvent<HTMLInputElement>);
		setIsModalOpen(false);
		notifySuccess('Response added');
	};

	return (
		<>
			<Box display={'flex'} flexDirection={'column'} rowGap={1}>
				{
					// If there are no autoFillDropdownItems, don't show the button
					(autoFillDropdownItems?.length ?? 0) > 0 && (
						<Button onClick={() => setIsModalOpen(true)}>
							View suggested responses
						</Button>
					)
				}

				<TextField
					value={value}
					fullWidth
					multiline
					label={label}
					onChange={onChange}
					error={error}
					helperText={helperText}
				/>
			</Box>
			<Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
				<Box sx={style}>
					<Box
						display={'flex'}
						justifyContent={'space-between'}
						alignItems={'center'}
					>
						<Typography variant="h6">Click to auto-fill</Typography>
						<IconButton onClick={() => setIsModalOpen(false)}>
							<ClearIcon />
						</IconButton>
					</Box>
					{autoFillDropdownItems?.map((item, index) => (
						<Box key={index}>
							<Card
								style={{ cursor: 'pointer' }}
								onClick={() =>
									onAutoFillDropdownItemClick(item)
								}
							>
								<CardContent>
									<Typography variant="caption">
										{item}
									</Typography>
								</CardContent>
							</Card>
						</Box>
					))}
				</Box>
			</Modal>
		</>
	);
};

export default CheckpointCommentResponse;
